export class EnvironmentApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public code?: number,
    public errors?: string[],
  ) {
    super(message);
    this.name = 'EnvironmentApiError';
  }

  getFullMessage(): string {
    if (!this.errors || this.errors.length === 0) {
      return this.message;
    }

    return `${this.message}: ${this.errors.join(', ')}`;
  }
}

export type FormattedError = {
  id: number;
  message: string;
  details?: string[];
  httpStatus?: number;
  apiCode?: number;
};

let nextErrorId = 0;

export function isEnvironmentApiError(
  error: unknown,
): error is EnvironmentApiError {
  // Duck-typing check - instanceof fails across module boundaries
  return (
    error instanceof Error &&
    error.name === 'EnvironmentApiError' &&
    'statusCode' in error
  );
}

export function formatApiError(error: unknown): FormattedError {
  const id = nextErrorId++;

  if (isEnvironmentApiError(error)) {
    const prefix = error.statusCode ? `HTTP ${error.statusCode}: ` : '';
    const suffix = error.code ? ` (Code ${error.code})` : '';
    return {
      id,
      message: `${prefix}${error.message}${suffix}`,
      details: error.errors,
      httpStatus: error.statusCode,
      apiCode: error.code,
    };
  }

  if (error instanceof Error) {
    return { id, message: error.message };
  }

  return { id, message: String(error) };
}
